import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const GraphicsCard = ({ onGraphicsCardSelected }) => {
  const [selectedGraphicsCard, setSelectedGraphicsCard] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.graphicscard) {
        const graphicsCardObject = firstResult.graphicscard;
        if (graphicsCardObject.trim() !== "") {
          setVariations(graphicsCardObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleGraphicsCardClick = (graphicscard) => {
    setSelectedGraphicsCard(graphicscard);
    onGraphicsCardSelected(graphicscard);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Graphics Card:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedGraphicsCard === variation ? "selected" : ""}`}
            onClick={() => handleGraphicsCardClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default GraphicsCard;
